import { Mail_VDIR, REDIRECT_URI_SUFFIX } from './constants';
import { getOrigin } from 'owa-url/lib/getOrigin';

/**
 * Returns the URL to a blank page for handling silent and popup flows
 */
export function getSilentRedirectUri(): string {
    return `${getOrigin()}${REDIRECT_URI_SUFFIX}`;
}

export function getLoginRedirectUri(): string {
    return `${getOrigin()}${Mail_VDIR}`;
}
